import React, { useState } from 'react';
import { Row } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';

import { useApplicationContext } from '@/context/v1/Application/context';
import { useDownloadFile } from '../hooks/hooks';
import type { SeraFile } from '@/types/Sera';
import { CustomTable, CustomDownloadButton } from './styles';

interface SubTableProps {
	data: SeraFile[];
}

export function SubTable({ data }: Readonly<SubTableProps>) {
	const [clickedFileId, setClickedFileId] = useState<string>('');

	const { organization, company } = useApplicationContext();
	const { isLoading: downloadingFile, mutateAsync: downloadFile } = useDownloadFile();

	async function handleOnDownloadFile(file: SeraFile): Promise<void> {
		setClickedFileId(file.id);
		await downloadFile({
			organization_id: organization?.id,
			company_id: company?.id,
			file: {
				id: file.id,
				original_name: file.original_name,
				generated_name: file.generated_name
			}
		});
	}

	const columns: ColumnsType<SeraFile> = [
		{
			title: '',
			dataIndex: '',
			key: 'empty1',
			align: 'center'
		},
		{
			title: '',
			dataIndex: '',
			key: 'empty2',
			align: 'center'
		},
		{
			title: '',
			dataIndex: '',
			key: 'empty3',
			align: 'center'
		},
		{
			title: '',
			dataIndex: 'original_name',
			key: 'original_name',
			ellipsis: true,
			align: 'center',
			render: (original_name: string, file: SeraFile) => (
				<CustomDownloadButton
					type="link"
					loading={file.id === clickedFileId && downloadingFile}
					onClick={() => handleOnDownloadFile(file)}
				>
					{original_name}
				</CustomDownloadButton>
			),
			responsive: ['lg']
		},
		{
			title: '',
			dataIndex: '',
			key: 'empty4',
			align: 'center'
		},
		{
			title: '',
			dataIndex: '',
			key: 'empty5',
			align: 'center'
		},
		{
			title: '',
			dataIndex: '',
			key: 'empty6',
			align: 'center'
		}
	];

	return (
		<Row justify="center">
			<CustomTable span={24}>
				<Table
					rowKey="id"
					dataSource={data}
					columns={columns}
					showHeader={false}
					pagination={false}
					style={{ cursor: 'auto' }}
				/>
			</CustomTable>
		</Row>
	);
}
